var React = require('react');

function Search1 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_37726","data-name":"Rectangle 37726","width":"22","height":"22","fill":"none","key":0}),React.createElement("path",{"id":"search-r","d":"M11,2.25a8.75,8.75,0,1,0,5.634,15.445L21,22.061,22.061,21l-4.366-4.366A8.75,8.75,0,0,0,11,2.25ZM3.75,11A7.25,7.25,0,1,1,11,18.25,7.25,7.25,0,0,1,3.75,11Z","transform":"translate(-0.789 -1.156)","fillRule":"evenodd","key":1})]);
}

Search1.defaultProps = {"id":"search1","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Search1;

Search1.default = Search1;
